import React from 'react';
import { roles } from '@nxsys/store/constants';

const ManageAccount = React.lazy(() => import('../../../modules/superAdmin'));

export const superAdminConfig = [
  {
    permittedRole: [roles.supper_admin],
    path: '/manage-account/:tabKey',
    element: <ManageAccount />,
  },
  {
    permittedRole: [roles.supper_admin],
    path: '/manage-account',
    element: <ManageAccount />,
  },
];
